import gql from 'graphql-tag';

const CREATE_EMPLOYEE = gql`
  mutation(
    $firstName: String
    $lastName: String
    $email: String
    $phoneNumber: String
    $contactNumber: String
    $countryCode: String
    $designation: DesignationInput
    $businessFunction: BusinessFunctionInput
    $team: TeamInput
    $role: RoleInput
    $addGroups: [GroupInput]
    $reportingManager: UserInput
    $roles: [RoleInput]
    $addAssociations: [CreateUserAssociationInput]
    $customFields: JSON
    $technicianBurnRate: String
  ) {
    createCompanyUser(
      input: {
        firstName: $firstName
        lastName: $lastName
        email: $email
        phoneNumber: $phoneNumber
        contactNumber: $contactNumber
        countryCode: $countryCode
        designation: $designation
        businessFunction: $businessFunction
        team: $team
        role: $role
        addGroups: $addGroups
        reportingManager: $reportingManager
        roles: $roles
        addAssociations: $addAssociations
        customFields: $customFields
        technicianBurnRate: $technicianBurnRate
      }
    ) {
      userId
      firstName
      lastName
      email
      phoneNumber
      contactNumber
      countryCode
      designation {
        designationId
        name
      }
      businessFunction {
        businessFunctionId
        name
      }
      team {
        teamId
        name
      }
      role {
        roleId
        name
      }
      reportingManager {
        userId
        firstName
        lastName
        email
      }
      groups {
        groupId
        name
      }
    }
  }
`;

const CREATE_EMPLOYEES = gql`
  mutation($input: [UserInput]) {
    createCompanyUsers(input: $input) {
      userId
      firstName
      lastName
      email
      phoneNumber
      designation {
        designationId
        name
      }
      businessFunction {
        businessFunctionId
        name
      }
      team {
        teamId
        name
      }
      role {
        roleId
      }
    }
  }
`;

const UPDATE_EMPLOYEE = gql`
  mutation(
    $userId: ID!
    $firstName: String
    $lastName: String
    $email: String
    $phoneNumber: String
    $contactNumber: String
    $countryCode: String
    $designation: DesignationInput
    $businessFunction: BusinessFunctionInput
    $team: TeamInput
    $reportingManager: UserInput
    $role: RoleInput
    $addGroups: [GroupInput]
    $roles: [RoleInput]
    $deleteGroups: [GroupInput]
    $deleteAssociations: [UserAssociationIdentifierInput]
    $updateAssociations: [UpdateUserAssociationInput]
    $addAssociations: [CreateUserAssociationInput]
    $customFields: JSON
    $technicianBurnRate: String
  ) {
    updateCompanyUser(
      input: {
        userId: $userId
        firstName: $firstName
        lastName: $lastName
        email: $email
        phoneNumber: $phoneNumber
        contactNumber: $contactNumber
        countryCode: $countryCode
        designation: $designation
        businessFunction: $businessFunction
        team: $team
        reportingManager: $reportingManager
        role: $role
        addGroups: $addGroups
        deleteGroups: $deleteGroups
        roles: $roles
        deleteAssociations: $deleteAssociations
        updateAssociations: $updateAssociations
        addAssociations: $addAssociations
        customFields: $customFields
        technicianBurnRate: $technicianBurnRate
      }
    ) {
      userId
      firstName
      lastName
      email
      phoneNumber
      contactNumber
      countryCode
      designation {
        designationId
        name
      }
      businessFunction {
        businessFunctionId
        name
      }
      team {
        teamId
        name
      }
      role {
        roleId
        name
      }
      roles {
        roleId
        name
      }
      reportingManager {
        userId
        firstName
        lastName
        email
      }
      groups {
        groupId
        name
      }
    }
  }
`;

export { UPDATE_EMPLOYEE, CREATE_EMPLOYEE, CREATE_EMPLOYEES };
